{
  "auth.login.otp.email.back.button_label": "Back",
  "auth.login.otp.email.cancel.button_label": "Cancel",
  "auth.login.otp.email.continue.button_label": "Continue",
  "auth.login.otp.email.error_format": "Please enter a valid email",
  "auth.login.otp.email.forgot_password.link_text": "Forgot password? Log in with passcode",
  "auth.login.otp.email.form.label": "Email",
  "auth.login.otp.email.form.placeholder": "Email",
  "auth.login.otp.email.passcode.form.helper_text": "Enter the code sent to",
  "auth.login.otp.email.passcode.form.label": "Code",
  "auth.login.otp.email.passcode.form.placeholder": "Code",
  "auth.login.otp.email.passcode.helper_text": "We'll email you a code to confirm your email.",
  "auth.login.otp.email.passcode.resend.link_text": "Didn’t get an email? Resend code",
  "auth.login.otp.email.passcode.resend.link_text.resending": "Resending...",
  "auth.login.otp.email.passcode.switch_method.link_text": "Send code to phone number instead",
  "auth.login.otp.email.password.label": "Password",
  "auth.login.otp.email.password.placeholder": "Password",
  "auth.login.otp.email.password.required": "Password is required"
}
